import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Supplier } from 'api/models/SupplierModel'
import { suppliersAPI } from 'api/supplier/suppliersAPI'
import { taxisAPI } from 'api/vehicle/taxisAPI'
import axios from 'axios'

export const getSuppliers: any = createAsyncThunk(
  'supplier/getSuppliers',
  async (self, { rejectWithValue }) => {
    try {
      var suppliers: any = []
      const response = await suppliersAPI.getSuppliers()
      response.data.value.forEach((supplier: any) => {
        suppliers.push(new Supplier(supplier))
      })
      return suppliers
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const updateTaxi: any = createAsyncThunk(
  'supplier/updateTaxi',
  async (payload: { taxiId: number; data: any }, thunkAPI) => {
    const { taxiId, data } = payload
    try {
      const response = await taxisAPI.updateTaxi(taxiId, data)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return thunkAPI.rejectWithValue(err.response.data)
      }
    }
  },
)

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState: {
    error: null,
    registration: undefined,
    contact: undefined,
    billing: undefined,
    supplier: undefined,
    selectedSupplier: undefined,
  },
  reducers: {
    createSupplier(state, action) {
      const newState = {
        ...action.payload,
      }
      state.registration = newState
    },
    createContact(state, action) {
      const newState = {
        ...action.payload,
      }
      state.contact = newState
    },
    createBilling(state, action) {
      const newState = {
        ...action.payload,
      }
      state.billing = newState
    },
    resetClientStore(state) {
      state.error = null
      state.registration = undefined
      state.contact = undefined
      state.billing = undefined
      state.selectedSupplier = undefined
      state.supplier = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSuppliers.rejected, (state: any, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
  },
})

export const { createContact, createBilling, resetClientStore } =
  suppliersSlice.actions

export default suppliersSlice.reducer
